import { Box, Button, Modal, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";

type Props = {
  isShown: boolean;
  onClose: any;
  message: string;
};

const ErrorModal = ({ isShown, onClose, message }: Props) => {
  const [open, setOpen] = useState<boolean>(isShown);

  useEffect(() => {
    setOpen(true);
    console.log(message);
  }, [message]);

  useEffect(() => {
    setOpen(isShown);
  }, [isShown]);

  return (
    <Modal
      id="duplicate-order-confirmation-modal"
      open={open}
      aria-labelledby="duplicate-order-modal-title"
      aria-describedby="duplicate-order-modal-description"
      onClose={onClose}
    >
      <Box
        sx={{
          textAlign: "center",
          position: "absolute",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
        }}
        id="duplicate-order-confirmation-box"
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Grid>
            <Typography variant="h2" fontSize={"1.5rem"}>
              Woops
            </Typography>
          </Grid>
          <Grid width={"100%"}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <React.Fragment>
                <Grid paddingBottom={2}>
                  <Typography variant="body1">{message}</Typography>
                </Grid>
                <Grid>
                  <Button variant="contained" color="neutral" onClick={onClose}>
                    Close
                  </Button>
                </Grid>
              </React.Fragment>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ErrorModal;
